<template>
    <div>
        <v-form
                v-model="model.valid"
                :ref="`loginForm`"
                v-if="!hideMainForm"
        >
            <v-row class="justify-center mx-0" v-if="error">
                <div class="row-content">
                    <v-alert type="error" v-if="error">
                        {{ error }}
                    </v-alert>
                </div>
            </v-row>
            <v-row class="justify-center mx-0">
                <div class="row-content">
                    <v-text-field
                            label="Email"
                            v-model="model.email"
                            required
                            :rules="rules.email"
                            color="orange lighten-2"
                            width="256px"
                    ></v-text-field>
                </div>
            </v-row>
            <v-row class="justify-center mx-0">
                <div class="row-content">
                    <v-text-field
                            label="Password"
                            required
                            v-model="model.password"
                            :type="passwordFieldType"
                            :append-icon="passwordIcon"
                            v-on:click:append="passwordVisibility"
                            :rules="rules.password"
                            color="orange lighten-2"
                            width="256px"
                    >
                    </v-text-field>
                </div>
            </v-row>
            <v-row class="justify-center mx-0">
                <div class="row-content text-right">
                    <router-link to="/account/password/forget" class="grey--text float-right f-s-12">{{ $t('forgetPassword') }}?</router-link>
                </div>
            </v-row>
            <v-row class="justify-center mx-0">
                <v-col cols="12" sm="12" class="text-center">
                    <v-btn
                            elevation="0"
                            class="main--yellow white--text px-4"
                            :disabled="!model.valid"
                            @click="sendData"
                    >
                        {{ $t('enter') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row class="justify-center align-center mx-0">
                <v-col cols="12" sm="3">
                    <hr>
                </v-col>
                <v-col cols="12" sm="2" class="text-center">
                    {{ $t('or') }}
                </v-col>
                <v-col cols="12" sm="3">
                    <hr>
                </v-col>
            </v-row>
            <v-row class="mx-0">
                <v-col cols="12" sm="12" class="d-flex justify-center">
                    <v-btn width="290" elevation="0" dark color="#ea4435" class="text-capitalize" @click="socialLogin('google')">
                        <v-icon left>mdi-google</v-icon>
                        {{ $t('enterWithHelp') }} Google
                    </v-btn>
                </v-col>
                <!--<v-col cols="12" sm="12"class="d-flex justify-center">
                    <v-btn width="290" elevation="0" dark color="#3d5997" class="text-capitalize" @click="socialLogin('facebook')">
                        <v-icon left>facebook</v-icon>
                        {{ $t('enterWithHelp') }} Facebook
                    </v-btn>
                </v-col>-->
            </v-row>
            <v-row class="justify-center mx-0">
                <v-col cols="12" sm="6" class="text-center">
                    <span style="color: #C4C4C4;" class="f-s-12">{{ $t('firstTimeAtFarmzi') }}</span>
                </v-col>
                <v-col cols="12" sm="6" class="text-center">
                    <router-link to="/registration" class="reg-link colored-link text-decorated-underline f-s-12">{{ $t('registration') }}</router-link>
                </v-col>
            </v-row>
        </v-form>
        <set-credentials v-if="hideMainForm"></set-credentials>
    </div>

</template>

<script>
    import AuthService from '../../../../app-front/services/api/AuthService';
    import Auth from '../../../../app-front/mixins/Auth';
    import SetCredentials from '../../../../views/front/account/SetCredentials';

    export default {
        name: "LoginComponent",
        mixins: [
            Auth
        ],
        props:['routerBack'],
        components: {
            SetCredentials
        },
        data() {
            return {
                error: false,
                isPasswordVisible: false,
                hideMainForm: false,
                model: {
                    email: '',
                    password: '',
                    valid: false
                },
                rules: {
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    password: [
                        v => !!v || this.$t('passwordRequired')
                    ]
                }
            }
        },
        computed: {
            passwordIcon() {
                return this.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye';
            },
            passwordFieldType() {
                return this.isPasswordVisible ? 'text' : 'password';
            }
        },
        methods: {
            passwordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible
            },
            sendData() {
                const credentials = {
                    email: this.model.email,
                    password: this.model.password
                };

                AuthService.login(credentials).then(res => {
                    if(!res.data.error) {
                        this.initLogin(res.data.success.token);
                        this.$emit('login-success');
                    } else {
                        this.$emit('login-failed');
                        this.initLogout();
                        this.showErrorMessage(res.data.error)
                    }
                })
                    .catch(err => {
                        console.log(err);
                        this.$emit('login-failed');
                        this.$store.commit('updateLoggedIn', false);
                        AuthService.resetAuthToken();
                        this.showErrorMessage('handler_error')
                    });
            },
            showErrorMessage(error) {
                switch(error) {
                    case 'unauthorized' : this.error = this.$t('wrongCredentials'); break;
                    case 'not_activated' : this.error = this.$t('notActivated'); break;
                    case 'deleted' : this.error = this.$t('accountDeleted'); break;

                    default : this.error = this.$t('loginError');
                }

                setTimeout(() => {
                    this.error = '';
                }, 3000);
            },
            socialLogin(provider) {
                const url = '/login/' + provider;
                let loginWindow = window.open(url, 'SocialLoginWindow', "resizable,scrollbars,status");

                const interval  = setInterval(() => {
                    if(loginWindow.closed) {
                        this.socialLoginHandle(interval, loginWindow);
                    }
                }, 500)
            },
            socialLoginHandle(interval, loginWindow) {
                window.authToken = loginWindow.authToken;
                window.authRedirectCredentials = loginWindow.authRedirectCredentials;

                if(!window.authToken) {
                    return false;
                }

                if(window.authRedirectCredentials) {
                    this.$router.push('/auth/credentials')
                        .then(res => {})
                        .catch(err => {console.log(err)});
                } else {
                    this.initLogin(loginWindow.authToken);
                }

                clearInterval(interval);
                this.$emit('login-success');
            }
        }
    }
</script>

<style scoped>

</style>
